export default {
    statistics: 'Statistika',

    statistic_option: {
        OFFER: 'Statistika rezervacija',
        REVENUE: 'Statistika prihoda',
        CUSTOM_RESERVATION_PRICE: 'Statistika potrošnje podsetnika',
        CUSTOM_RESERVATION_SEND: 'Statistika poslatih podsetinka',
    },

    total: {
        offer: 'Ukupan broj rezervacija: ',
        revenue: 'Ukupan prihod: ',
    },

    reminder: {
        label: 'Podsetnik',
        placeholder: 'Izaberite podsetnik',
    },
}
